var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"appear":"","name":"home"}},[_c('div',{staticClass:"home"},[_c('div',{staticClass:"main"},[_c('h1',[_vm._v("Draw")]),_c('p',[_vm._v("A collaborative drawing application.")]),_c('button',{staticClass:"button primary",on:{"click":_vm.createRoom}},[_vm._v(" Create a room ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }